import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { fetch, setupFetchData, urls, urlParams, webIM, postMessage, onPostMessage, replaceTpl, getAttr } from './utils';
import { Audio } from './ui';
import * as SessionActions from './session/redux';
import * as MsgActions from './msg/redux';
import * as UserActions from './user/redux';
import * as GroupActions from './group/redux';
import SessionList from './session/list';
import Header from './header';
import MsgList from './msg/list';
import MsgEditor from './msg/editor';

class App extends Component {
    state = {};

    constructor(props) {
        super(props)

        let params = urlParams();
        urls.setApiRoot(params.api_root);

        if (!this.validAuth(params)) {
            // return alert("非法进入！");
            return;
        }

        webIM.connect(_.extend({}, params, {
            onMessage: this.onMessage.bind(this),
            onAction: this.onAction.bind(this),
            onPresence: this.onPresence.bind(this)
        }));
        setupFetchData(_.pick(params, "jid", "access_token"));
        this.params = params;
        this.unread_count = 0;
        this.clickSessionCount = 0;

        onPostMessage((type) => {
            switch (type) {
                case 'show':
                case 'hide':
                    this.isWindowOpen = type === 'show';
                    this.postUnreadCount();
                    break;
            }
        });
    }

    validAuth(params) {
        params = params || this.params;
        return params.api_root && params.jid && params.password && params.company_jid && params.access_token && params.im_server;
    }

    activeSessionId(id) {
        let key = 'active_session_id';
        if (!_.isUndefined(id)) {
            localStorage[key] = id;
        } else {
            id = parseInt(localStorage[key]) || 0;
        }
        return id;
    }

    tryLastActiveSession() {
        const { sessionData } = this.props;
        let active_session = _.find(sessionData, { id: this.activeSessionId() });
        if (active_session) {
            this.refs.sessionList.clickSession(active_session);
        }
    }

    async componentWillMount() {
        const { sessionActions, userActions, groupActions } = this.props;

        let res = await fetch(urls.api.init_data, {
            method: "POST"
        });

        //#test
        // res = require('./tests').init_data;

        if (res.ok) {
            this.state.user = res.user;
            userActions.add(res.users);
            groupActions.add(res.groups);
            sessionActions.loadRelatedData({ user_jid: res.user.jid });
            sessionActions.add(res.sessions);
            webIM.ready(() => webIM.setupGroups(res.groups));
            this.postUnreadCount();
            this.tryLastActiveSession();
        } else {
            // window.alert(res.message);
        }
    }

    postUnreadCount() {
        const { sessionData } = this.props;

        if (this.isWindowOpen) {
            let unread_count = 0;
            _.each(sessionData, (item) => {
                unread_count += (item.unread_count || 0);
            });
            this.unread_count = unread_count;
        }

        postMessage('msg_unread_count', { unread_count: this.unread_count });
    }

    closeWindow(ev){
        this.isWindowOpen = false;
        postMessage('hideCard');
    }

    async onMessage(type, message) {
        const { msgData, userData, sessionData, msgActions, sessionActions } = this.props;
        const loginUser = this.state.user;
        const { body } = message;
        const { session_id, user_jid, message_id } = body;
        const user = _.find(userData, { jid: user_jid }) || {};
        const refs = this.refs;

        let session = _.find(sessionData, { id: session_id });
        let msg = _.find(msgData, { id: message_id });

        this.refs.audio.playAudio();
        if (!session) {
            session = { id: session_id };
            let res = await refs.msgList.loadData({ session });
            if (res.ok) {
                session = _.omit(res, 'messages');
                session.last_msg = _.last(res.messages);
                session.updated_at = new Date();
                session.unread_count = 1;
                this.unread_count++;
                refs.sessionList.addOrEditSession(session);
            }
            this.postUnreadCount();
            return;
        }

        if (!msg) {
            msg = _.extend({
                    session_id,
                    message_id,
                    body,
                    is_received: user.jid !== loginUser.jid
                },
                _.pick(message, 'from', 'to'),
                _.pick(user, 'nick_name', 'avatar')
            );
        }

        msgActions.addOrEdit(msg);
        session.last_msg = msg;
        session.msg_num = body.msg_num;
        if (!session.is_active) {
            let unread_count = session.unread_count || 0;
            session.unread_count = ++unread_count;
        }
        if (!this.isWindowOpen) {
            this.unread_count++;
        }
        sessionActions.addOrEdit(session);

        this.postUnreadCount();
    }

    async onAction(type, message) {
        const { sessionData, groupActions, sessionActions } = this.props;
        const { body } = message;
        const { session_id, jid } = body;
        const refs = this.refs;

        let session = _.find(sessionData, { id: session_id });

        switch (type) {
            case 'NewSession':
                let res = await fetch(replaceTpl(urls.api.session.get, { id: session_id }))
                if (res.ok) {
                    refs.sessionList.addOrEditSession(res.session);
                }
                break;
            case 'QuitSession':
                if (session && jid) {
                    sessionActions.removeUser(session.id, jid);
                    groupActions.removeUser(session.jid, jid);
                }
                break;
        }
    }

    onPresence(type, presence) {
        const { userData, userActions, groupActions, sessionActions } = this.props;
        const { user_id, body = {} } = presence;
        let { user_jid } = body;

        if (!user_jid && user_id) {
            user_jid = getAttr(_.find(userData, { id: user_id }), 'jid');
        }

        switch (type) {
            case 'online':
            case 'offline':
                if (user_jid) {
                    let tarUser = {
                        jid: user_jid,
                        status: type
                    };
                    userActions.edit(tarUser);
                    groupActions.editUser(tarUser);
                    sessionActions.editUser(tarUser);
                }
                break;
            default:
                break;
        }
    }

    async onClickSession(session) {
        let refs = this.refs;

        refs.header && refs.header.tigger('shrink');
        if (session) {
            let res = await refs.msgList.loadData({ session, scroll: true });
            if (res.ok) {
                session.last_msg = _.last(res.messages);
            }
        }
        this.setState({ session: session });
        this.clickSessionCount && this.postUnreadCount();
        this.activeSessionId(session ? session.id : 0);
        this.clickSessionCount++;
    }

    async onSaveGroup({ srcSession, group, add_users }) {
        let refs = this.refs;
        let session = await refs.sessionList.createSessionByGroup({
            group,
            add_users
        });

        if (session) {
            refs.sessionList.clickSession(session);
        }
    }

    onReSend(msg) {
        this.refs.msgEditor.sendMsg(msg);
    }

    onQuit(session) {
        const { groupActions } = this.props;

        let activeSession;

        groupActions.remove(session.jid);
        activeSession = this.refs.sessionList.removeSession(session);
        this.refs.sessionList.clickSession(activeSession);
    }

    onWillSendMsg(msg, session) {
        const { sessionActions } = this.props;

        session.last_msg = msg;
        session.updated_at = new Date();
        sessionActions.addOrEdit(session);
    }

    onDidSendMsg() {
        this.refs.msgList.goBottom();
    }

    render() {
        const { sessionData, userData, groupData, msgData } = this.props;
        const { sessionActions, userActions, groupActions, msgActions } = this.props;
        let { user, session } = this.state;
        let audioProps = {
            src: urls.mp3Root + 'msg_audio.mp3',
            className: 'invisible audio-msg',
            id: 'msg-audio'
        }
        return (
            <div id="app" className="flex flex-h">
              <main className="flex flex-v">
                {
                    session ? (
                        <Header ref="header"
                                user={user}
                                session={session}
                                userData={userData}
                                sessionActions={sessionActions}
                                groupActions={groupActions}
                                onSaveGroup={this.onSaveGroup.bind(this)}
                                onClose={(session)=>{this.refs.sessionList.closeSession(session)}}
                                onQuit={this.onQuit.bind(this)}/>
                    ) : null
                }
                <MsgList ref="msgList"
                         session={session}
                         user={user}
                         data={msgData}
                         userData={userData}
                         actions={msgActions}
                         onReSend={this.onReSend.bind(this)} />
                {
                    session ? (
                    <footer>
                        <MsgEditor ref="msgEditor"
                                   user={user} session={session} msgData={msgData}
                                   actions={msgActions}
                                   onWillSendMsg={this.onWillSendMsg.bind(this)}
                                   onDidSendMsg={this.onDidSendMsg.bind(this)}/>
                    </footer>
                    ) : null
                }
              </main>
              <aside className="flex flex-v">
                {
                    /*<Clearfix>
                      <Left>
                        {
                          user ? (
                            <Avatar type="normal"
                                    src={user.avatar}
                                    text={user.nick_name}
                                    width={20}
                                    height={20}
                                    className="online" />
                          ) : null
                        }
                      </Left>
                      <Right></Right>
                    </Clearfix>*/
                }
                <a className="btn-close-card icon icon-close" onClick={this.closeWindow.bind(this)}/>
                <SessionList ref="sessionList"
                          user={user}
                          sessionData={sessionData} userData={userData} groupData={groupData} msgData={msgData}
                          sessionActions={sessionActions} userActions={userActions} groupActions={groupActions} msgActions={msgActions}
                          onClickSession={this.onClickSession.bind(this)} />
              </aside>
              <Audio ref="audio" {...audioProps} />
            </div>
        );
    }
}

App.propTypes = {
    sessionData: PropTypes.array,
    msgData: PropTypes.array,
    userData: PropTypes.array,
    groupData: PropTypes.array,
    sessionActions: PropTypes.object,
    msgActions: PropTypes.object,
    userActions: PropTypes.object,
    groupActions: PropTypes.object
}

function mapStateToProps(state) {
    return {
        sessionData: state.sessionData,
        msgData: state.msgData,
        userData: state.userData,
        groupData: state.groupData
    }
}

function mapDispatchToProps(dispatch) {
    return {
        sessionActions: bindActionCreators(SessionActions, dispatch),
        msgActions: bindActionCreators(MsgActions, dispatch),
        userActions: bindActionCreators(UserActions, dispatch),
        groupActions: bindActionCreators(GroupActions, dispatch)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js